import "./signupScreen2Styles.css";

import vectorArt from "../../assets/signup-screen2.svg";
import dotsBottom from "../../assets/login-dots-bottom.svg";
import dotsTop from "../../assets/login-dots-top.svg";
import logo from "../../assets/top-nav-logo.svg";

import { useState } from "react";
import { useForm, Controller } from "react-hook-form";

import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import Button from "../design/Button";
import { enqueueSnackbar } from "notistack";
import { CustomInput } from "../design/components/customComponents";

const API_BASE_URL = process.env.REACT_APP_BETA;
function SignupScreen2() {
    const navigate = useNavigate();

    const userLoginAttemptWith = useSelector((state) => state.user.value);

    const [showLoader, setShowLoader] = useState(false)

    const {
        control,
        watch,
        trigger,
        reset,
        resetField,
        formState: { errors, isValid }
    } = useForm({
        defaultValues: {
            emailOtp: ""
        },
        mode: "onChange"
    });

    const emailOtp = watch("emailOtp");


    const handleSubmit = e => {
        e.preventDefault()

        setShowLoader(true)
        fetch(API_BASE_URL + '/api/v1/auth/verify-account/?webapp=True&source=web', {
            method: 'post',
            body: JSON.stringify({ email: userLoginAttemptWith?.email?.value, code: emailOtp }),
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
        })
            .then(res => {
                if (res?.status === 500) throw new Error('Server error please try again or if issue persists contact FreJun')
                return res?.json()
            })
            .then(res => {
                if (!res?.success) throw new Error(res?.message || "Error occurred while verifying code")
                navigate('/signup/company-details')
            })
            .catch(err => enqueueSnackbar(err?.message || 'Error occurred while verifying code', { variant: "error" }))
            .finally(() => {
                reset();
                setShowLoader(false);
            })
    }

    const handleResendCode = e => {
        const _body = {
            email: userLoginAttemptWith?.email?.value,
            source: 'login'
        }
        fetch(API_BASE_URL + '/api/v1/auth/send-code/', {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'post',
            body: JSON.stringify(_body)
        }).then(res => {
            if (res?.status === 500) throw new Error('Server error please try again or if issue persists contact FreJun.')
            return res?.json()
        })
            .then(res => {
                if (!res?.success) throw Error('Fetching account details failed')
                enqueueSnackbar(res?.message || 'Code resent', { variant: "success" })
            })
            .catch(err => enqueueSnackbar(err?.message || 'Error occurred while resending code', { variant: "error" }))
            .finally(() => {
                // reset code
                resetField("emailOtp");
            })
    }

    return (
        <div className='signup-screen-container color-2d'>
            <div className='signup-art'>
                <a href="https://frejun.com/" target="_blank" rel="noopener noreferrer"> <img src={logo} alt="Logo" /></a>
                <img src={dotsTop} />
                <img src={vectorArt} />
                <img src={dotsBottom} />
            </div>
            <div className='signup-screen2-form'>
                <p className='title t5 medium-font' style={{ marginTop: "0" }}>Verify email</p>
                <form style={{ display: "flex", flexDirection: "column", gap: "3.5em" }} onSubmit={e => handleSubmit(e)}>
                    <div>
                        <Controller
                            name="emailOtp"
                            control={control}
                            rules={{
                                required: "Email OTP is required",
                                validate: (value) => {
                                    const v = (value || "")
                                        .replace(/[^a-zA-Z0-9]/g, "")
                                        .toUpperCase();

                                    return /^[A-Z0-9]{6}$/.test(v) || "Email OTP must be exactly 6 characters (A-Z, 0-9)";
                                }
                            }}
                            render={({ field }) => (
                                <CustomInput
                                    labelStyles={{ marginBottom: "6px" }}
                                    label={
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                            <span>Please enter the verification code sent to <strong>{userLoginAttemptWith?.email?.value}</strong></span>
                                        </span>
                                    }
                                    name={field.name}
                                    type="text"
                                    placeholder="Enter code"
                                    value={{
                                        value: field.value || "",
                                        error: errors.emailOtp?.message || ""
                                    }}
                                    handleChange={(e) => {
                                        const alphaNumericUpper = (e.target.value || "")
                                            .replace(/[^a-zA-Z0-9]/g, "")
                                            .toUpperCase()
                                            .slice(0, 6);

                                        field.onChange(alphaNumericUpper); // ✅ single source of truth
                                    }}
                                    handleBlur={() => {
                                        field.onBlur();
                                        trigger("emailOtp");
                                    }}
                                    inputProps={{
                                        maxLength: 6,
                                        autoComplete: "one-time-code",
                                        className: "otp-input"
                                    }}
                                />
                            )}
                        />
                        <p className='send-again t7 regular-font' onClick={e => handleResendCode(e)}>Didn't receive code? <span className='color-green' style={{ cursor: "pointer" }}>Send again</span></p>
                    </div>


                    <div className='buttons-container btnscreen2 ' style={{ justifyContent: 'flex-end', marginTop: "0" }}>
                        <Button
                            className='btns2'
                            hierarchy="green"
                            variant="contained"
                            buttonText="Verify"
                            onClick={handleSubmit}
                            disabled={
                                showLoader ||
                                !isValid
                            }
                            styleOverride={{ width: '100%' }}
                            spanStyles={{ width: '100%' }}
                            isLoading={showLoader}
                        />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default SignupScreen2;
